//MARK: Done
import makeApiRequest from "./clients/apiRequest";
import { gateway } from "./clients/baseClient";
import { versionApiPath } from "./common";
import { ENDPOINTS } from "./endpoints";
import { AccountAddBody } from "./types/account";
import { ResponseData } from "./types/api";


export async function createAccount(
  body: AccountAddBody
): Promise<ResponseData> {

  body.creator = "In4mDash";
  const data = {
    endpoint: `${versionApiPath}/${ENDPOINTS.ACCOUNT.ADD}`,
    body: body
  };
  return await makeApiRequest(
    {
      url: ``,
      method: "post",
      data: data,
    },
    gateway,
    true
  );
}
